import React, { useState } from 'react';

import CoreSwitch, { type SwitchChangeEvent } from '~/components/ui/atoms/Switch';

export interface AutoSaveSwitchProps {
  checked: boolean;
  onSave: (checked: boolean) => Promise<void>; // The async action to perform on change
  disabled?: boolean;
  // We can extend this later if we need to pass more props to CoreSwitch (e.g., className)
}

const AutoSaveSwitch: React.FC<AutoSaveSwitchProps> = ({ checked, onSave, disabled }) => {
  const [isSaving, setIsSaving] = useState(false);

  const handleChange = async (_event: SwitchChangeEvent, newCheckedState: boolean) => {
    setIsSaving(true);
    try {
      await onSave(newCheckedState);
    } finally {
      setIsSaving(false);
    }
  };

  return <CoreSwitch checked={checked} onChange={handleChange} disabled={disabled || isSaving} />;
};

export default AutoSaveSwitch;
